// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-area {
  position: relative;
  z-index: 1;
}
.about-area.bg-gradient-image {
  background-image: url('bg2.0418027ecede705e.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.about-image {
  z-index: 1;
  text-align: center;
  padding-right: 15px;
  position: relative;
}
.about-image img {
  animation: border-transform 10s linear infinite alternate forwards;
}

.about-content {
  padding-left: 15px;
}
.about-content .sub-title {
  background-color: rgba(2, 152, 148, 0.15);
  transition: var(--transition);
  color: var(--mainColor);
  display: inline-block;
  margin-bottom: 15px;
  letter-spacing: 1px;
  border-radius: 5px;
  padding: 4px 30px;
  font-size: 14px;
  font-weight: 300;
}
.about-content .sub-title:hover {
  background-color: var(--mainColor);
  color: var(--whiteColor);
}
.about-content h2 {
  margin-bottom: 10px;
  font-size: 40px;
  font-weight: 400;
  font-family: var(--fontFamily2);
}
.about-content p {
  max-width: 520px;
}
.about-content .features-list {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  margin-top: -15px;
  margin-left: -15px;
  margin-right: -15px;
}
.about-content .features-list li {
  margin-top: 30px;
  flex: 0 0 auto;
  width: 50%;
  padding-left: 15px;
  padding-right: 15px;
}
.about-content .features-list li .icon {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 5px;
  text-align: center;
  transition: var(--transition);
  background-color: var(--whiteColor);
}
.about-content .features-list li span {
  display: block;
  margin-left: 20px;
  font-size: 24px;
  font-weight: 600;
}
.about-content .features-list li:hover .icon {
  border-radius: 50%;
}
.about-content .default-btn {
  margin-top: 30px;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .about-image {
    padding-right: 0;
  }
  .about-content {
    padding-left: 0;
    text-align: center;
    margin-top: 30px;
  }
  .about-content .sub-title {
    padding: 3px 15px;
    font-size: 12px;
  }
  .about-content h2 {
    font-size: 25px;
  }
  .about-content p {
    max-width: 100%;
  }
  .about-content .features-list {
    margin-left: -10px;
    margin-right: -10px;
  }
  .about-content .features-list li {
    padding-left: 10px;
    padding-right: 10px;
  }
  .about-content .features-list li .d-flex {
    display: block !important;
  }
  .about-content .features-list li .icon {
    width: 80px;
    height: 80px;
    line-height: 80px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
  }
  .about-content .features-list li .icon img {
    width: 45px;
  }
  .about-content .features-list li span {
    margin-left: 0;
    font-size: 16px;
  }
  .single-features-card {
    padding: 20px 15px;
  }
  .single-features-card .image {
    margin-bottom: 20px;
  }
  .single-features-card h3 {
    font-size: 20px;
    margin-bottom: 12px;
  }
}
/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .about-content .features-list li {
    width: 25%;
  }
}
/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .about-image {
    padding-right: 0;
    margin-bottom: 30px;
  }
  .about-content {
    padding-left: 0;
    text-align: center;
  }
  .about-content .sub-title {
    padding: 4px 20px;
    font-size: 13px;
  }
  .about-content h2 {
    font-size: 32px;
  }
  .about-content p {
    max-width: 540px;
    margin-left: auto;
    margin-right: auto;
  }
  .about-content .features-list li {
    width: 25%;
  }
  .about-content .features-list li .d-flex {
    display: block !important;
  }
  .about-content .features-list li .d-flex .icon {
    border-radius: 50%;
    margin-left: auto;
    margin-right: auto;
  }
  .about-content .features-list li .d-flex span {
    font-size: 20px;
    margin-left: 0;
    margin-top: 15px;
  }
  .single-features-card {
    padding: 25px 20px;
  }
  .single-features-card .image {
    margin-bottom: 20px;
  }
  .single-features-card h3 {
    font-size: 20px;
    margin-bottom: 12px;
  }
}
/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .about-image {
    padding-right: 0;
  }
  .about-content {
    padding-left: 0;
  }
  .about-content h2 {
    font-size: 36px;
  }
  .about-content p {
    max-width: 100%;
  }
  .about-content .features-list li .icon {
    width: 77px;
    height: 77px;
    line-height: 77px;
  }
  .about-content .features-list li span {
    margin-left: 15px;
    font-size: 18px;
  }
}
/* Min width 1200px to Max width 1399px */
/* Min width 1600px */
.image img {
  max-width: 80px;
}

.single-features-card {
  border: 1px solid #E5E5E5;
  background-color: var(--whiteColor);
  border-radius: 25px;
  margin-bottom: 30px;
  padding: 40px 30px;
  text-align: center;
  height: 100%;
  transition: var(--transition);
}
.single-features-card .image {
  margin-bottom: 25px;
}
.single-features-card h3 {
  margin-bottom: 13px;
  font-size: 24px;
  font-weight: 600;
}
.single-features-card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 25px 65px rgba(2, 152, 148, 0.08);
  border: 1px solid var(--mainColor);
}
.single-features-card.with-black-color {
  text-align: start;
  background-color: #131A34;
  border: 1px solid #131A34;
}
.single-features-card.with-black-color h3 {
  color: var(--whiteColor);
}
.single-features-card.with-black-color p {
  color: var(--whiteColor);
}
.single-features-card.with-black-color:hover {
  box-shadow: unset;
  border: 1px solid #131A34;
}

.show-phone-number {
  background: #11b3a4;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.z-10 {
  z-index: 10;
}
.m-0 {
  margin: 0px;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.size-11 {
  width: 2.75rem;
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-5 {
  height: 1.25rem;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-full {
  height: 100%;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.columns-3 {
  columns: 3;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-none {
  border-style: none;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
@media (min-width: 768px) {
  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .md\\:block {
    display: block;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:justify-center {
    justify-content: center;
  }
  .md\\:p-2 {
    padding: 0.5rem;
  }
}
@media (prefers-color-scheme: dark) {
  .dark\\:border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }
  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }
  .dark\\:text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/pages/home-demo-four/establishment-detail/establishment-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;AACJ;AACI;EAEQ,iDAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;AAAZ;;AAIA;EACI,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAGI;EACI,kEAAA;AADR;;AAIA;EACI,kBAAA;AADJ;AAGI;EACI,yCAAA;EACA,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EAEI,eAAA;EACA,gBAAA;AAFZ;AAIQ;EACI,kCAAA;EACA,wBAAA;AAFZ;AAKI;EACI,mBAAA;EAEI,eAAA;EACA,gBAAA;EACA,+BAAA;AAJZ;AAOI;EACI,gBAAA;AALR;AAOI;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EAEI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AANZ;AAQQ;EACI,gBAAA;EACA,cAAA;EACA,UAAA;EAEI,kBAAA;EACA,mBAAA;AAPhB;AASY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mCAAA;AAPhB;AASY;EACI,cAAA;EACA,iBAAA;EAEI,eAAA;EACA,gBAAA;AARpB;AAYgB;EACI,kBAAA;AAVpB;AAeI;EACI,gBAAA;AAbR;;AAiBA,oBAAA;AACA;EAEI;IACI,gBAAA;EAfN;EAiBE;IACI,eAAA;IACA,kBAAA;IACA,gBAAA;EAfN;EAiBM;IACI,iBAAA;IACA,eAAA;EAfV;EAiBM;IACI,eAAA;EAfV;EAiBM;IACI,eAAA;EAfV;EAiBM;IAEQ,kBAAA;IACA,mBAAA;EAhBd;EAkBU;IAEQ,kBAAA;IACA,mBAAA;EAjBlB;EAmBc;IACI,yBAAA;EAjBlB;EAmBc;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IAEI,iBAAA;IACA,kBAAA;IACA,mBAAA;EAlBtB;EAoBkB;IACI,WAAA;EAlBtB;EAqBc;IACI,cAAA;IACA,eAAA;EAnBlB;EAyBA;IACE,kBAAA;EAvBF;EAyBE;IACE,mBAAA;EAvBJ;EAyBE;IACE,eAAA;IACA,mBAAA;EAvBJ;AACF;AA4BA,uCAAA;AACA;EAIY;IACI,UAAA;EA7Bd;AACF;AAmCA,uCAAA;AACA;EAEI;IACI,gBAAA;IACA,mBAAA;EAlCN;EAoCE;IACI,eAAA;IACA,kBAAA;EAlCN;EAoCM;IACI,iBAAA;IACA,eAAA;EAlCV;EAoCM;IACI,eAAA;EAlCV;EAoCM;IACI,gBAAA;IAEI,iBAAA;IACA,kBAAA;EAnCd;EAuCU;IACI,UAAA;EArCd;EAuCc;IACI,yBAAA;EArClB;EAuCkB;IACI,kBAAA;IAEI,iBAAA;IACA,kBAAA;EAtC1B;EAyCkB;IACI,eAAA;IAEI,cAAA;IACA,gBAAA;EAxC1B;EA+CA;IACE,kBAAA;EA7CF;EA+CE;IACE,mBAAA;EA7CJ;EA+CE;IACE,eAAA;IACA,mBAAA;EA7CJ;AACF;AAkDA,wCAAA;AACA;EAEI;IACI,gBAAA;EAjDN;EAmDE;IACI,eAAA;EAjDN;EAmDM;IACI,eAAA;EAjDV;EAmDM;IACI,eAAA;EAjDV;EAqDc;IACI,WAAA;IACA,YAAA;IACA,iBAAA;EAnDlB;EAqDc;IACI,iBAAA;IACA,eAAA;EAnDlB;AACF;AA0DA,yCAAA;AAGA,qBAAA;AAIA;EACE,eAAA;AA7DF;;AAgEA;EACE,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;AA7DF;AA+DE;EACE,mBAAA;AA7DJ;AA+DE;EACE,mBAAA;EAEE,eAAA;EACA,gBAAA;AA9DN;AAiEE;EACE,2BAAA;EACA,iDAAA;EACA,kCAAA;AA/DJ;AAiEE;EACE,iBAAA;EACA,yBAAA;EACA,yBAAA;AA/DJ;AAiEI;EACE,wBAAA;AA/DN;AAiEI;EACE,wBAAA;AA/DN;AAiEI;EACE,iBAAA;EACA,yBAAA;AA/DN;;AAoEA;EACE,mBAAA;AAjEF;;AAmEA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA,kEAAA;;AAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;;AAAA;EAAA,aAAA;AAAA;AACA;EAAA,WAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AACA;EAAA,oBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,cAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA;IAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,2BAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,6BAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,eAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,kDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AApVA;EAAA,kBAoVA;EApVA,0DAAA;AAoVA;AApVA;EAAA,kBAoVA;EApVA,4DAAA;AAoVA;AApVA;EAAA,kBAoVA;EApVA,yDAAA;AAoVA;AApVA;EAAA,+BAAA;AAoVA;AApVA;EAAA,+EAoVA;EApVA,mGAoVA;EApVA,uGAAA;AAoVA;AApVA;EAAA,8BAoVA;EApVA,mBAAA;AAoVA;AApVA;EAAA,2GAoVA;EApVA,yGAoVA;EApVA,4FAAA;AAoVA;AApVA;EAAA,oBAoVA;EApVA,6DAAA;AAoVA;AApVA;EAAA;IAAA,4BAAA;EAoVA;EApVA;IAAA,4BAAA;EAoVA;EApVA;IAAA,cAAA;EAoVA;EApVA;IAAA,aAAA;EAoVA;EApVA;IAAA,gDAAA;EAoVA;EApVA;IAAA,gDAAA;EAoVA;EApVA;IAAA,uBAAA;EAoVA;EApVA;IAAA,eAAA;EAoVA;AAAA;AApVA;EAAA;IAAA,sBAoVA;IApVA,yDAAA;EAoVA;EApVA;IAAA,kBAoVA;IApVA,yDAAA;EAoVA;EApVA;IAAA,kBAoVA;IApVA,yDAAA;EAoVA;EApVA;IAAA,oBAoVA;IApVA,mDAAA;EAoVA;EApVA;IAAA,kBAoVA;IApVA,yDAAA;EAoVA;EApVA;IAAA,kBAoVA;IApVA,yDAAA;EAoVA;EApVA;IAAA,oBAoVA;IApVA,mDAAA;EAoVA;AAAA;AA8gCA,o0rBAAo0rB","sourcesContent":[".about-area {\n    position: relative;\n    z-index: 1;\n\n    &.bg-gradient-image {\n        background: {\n            image: url(../../../../../assets/img/bg/bg2.jpg);\n            position: center center;\n            repeat: no-repeat;\n            size: cover;\n        };\n    }\n}\n.about-image {\n    z-index: 1;\n    text-align: center;\n    padding-right: 15px;\n    position: relative;\n\n    img {\n        animation: border-transform 10s linear infinite alternate forwards;\n    }\n}\n.about-content {\n    padding-left: 15px;\n\n    .sub-title {\n        background-color: rgba(2, 152, 148, .15);\n        transition: var(--transition);\n        color: var(--mainColor);\n        display: inline-block;\n        margin-bottom: 15px;\n        letter-spacing: 1px;\n        border-radius: 5px;\n        padding: 4px 30px;\n        font: {\n            size: 14px;\n            weight: 300;\n        };\n        &:hover {\n            background-color: var(--mainColor);\n            color: var(--whiteColor);\n        }\n    }\n    h2 {\n        margin-bottom: 10px;\n        font: {\n            size: 40px;\n            weight: 400;\n            family: var(--fontFamily2);\n        };\n    }\n    p {\n        max-width: 520px;\n    }\n    .features-list {\n        display: flex;\n        flex-wrap: wrap;\n        padding-left: 0;\n        list-style-type: none;\n        margin: {\n            bottom: 0;\n            top: -15px;\n            left: -15px;\n            right: -15px;\n        };\n        li {\n            margin-top: 30px;\n            flex: 0 0 auto;\n            width: 50%;\n            padding: {\n                left: 15px;\n                right: 15px;\n            };\n            .icon {\n                width: 100px;\n                height: 100px;\n                line-height: 100px;\n                border-radius: 5px;\n                text-align: center;\n                transition: var(--transition);\n                background-color: var(--whiteColor);\n            }\n            span {\n                display: block;\n                margin-left: 20px;\n                font: {\n                    size: 24px;\n                    weight: 600;\n                };\n            }\n            &:hover {\n                .icon {\n                    border-radius: 50%;\n                }\n            }\n        }\n    }\n    .default-btn {\n        margin-top: 30px;\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width : 767px) {\n\n    .about-image {\n        padding-right: 0;\n    }\n    .about-content {\n        padding-left: 0;\n        text-align: center;\n        margin-top: 30px;\n\n        .sub-title {\n            padding: 3px 15px;\n            font-size: 12px;\n        }\n        h2 {\n            font-size: 25px;\n        }\n        p {\n            max-width: 100%;\n        }\n        .features-list {\n            margin: {\n                left: -10px;\n                right: -10px;\n            };\n            li {\n                padding: {\n                    left: 10px;\n                    right: 10px;\n                };\n                .d-flex {\n                    display: block !important;\n                }\n                .icon {\n                    width: 80px;\n                    height: 80px;\n                    line-height: 80px;\n                    margin: {\n                        left: auto;\n                        right: auto;\n                        bottom: 15px;\n                    };\n                    img {\n                        width: 45px;\n                    }\n                }\n                span {\n                    margin-left: 0;\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n\n  .single-features-card {\n    padding: 20px 15px;\n\n    .image {\n      margin-bottom: 20px;\n    }\n    h3 {\n      font-size: 20px;\n      margin-bottom: 12px;\n    }\n  }\n\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width : 576px) and (max-width : 767px) {\n\n    .about-content {\n        .features-list {\n            li {\n                width: 25%;\n            }\n        }\n    }\n\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width : 768px) and (max-width : 991px) {\n\n    .about-image {\n        padding-right: 0;\n        margin-bottom: 30px;\n    }\n    .about-content {\n        padding-left: 0;\n        text-align: center;\n\n        .sub-title {\n            padding: 4px 20px;\n            font-size: 13px;\n        }\n        h2 {\n            font-size: 32px;\n        }\n        p {\n            max-width: 540px;\n            margin: {\n                left: auto;\n                right: auto;\n            };\n        }\n        .features-list {\n            li {\n                width: 25%;\n\n                .d-flex {\n                    display: block !important;\n\n                    .icon {\n                        border-radius: 50%;\n                        margin: {\n                            left: auto;\n                            right: auto;\n                        };\n                    }\n                    span {\n                        font-size: 20px;\n                        margin: {\n                            left: 0;\n                            top: 15px;\n                        };\n                    }\n                }\n            }\n        }\n    }\n  .single-features-card {\n    padding: 25px 20px;\n\n    .image {\n      margin-bottom: 20px;\n    }\n    h3 {\n      font-size: 20px;\n      margin-bottom: 12px;\n    }\n  }\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width : 992px) and (max-width : 1199px) {\n\n    .about-image {\n        padding-right: 0;\n    }\n    .about-content {\n        padding-left: 0;\n\n        h2 {\n            font-size: 36px;\n        }\n        p {\n            max-width: 100%;\n        }\n        .features-list {\n            li {\n                .icon {\n                    width: 77px;\n                    height: 77px;\n                    line-height: 77px;\n                }\n                span {\n                    margin-left: 15px;\n                    font-size: 18px;\n                }\n            }\n        }\n    }\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {}\n\n/* Min width 1600px */\n@media only screen and (min-width: 1600px) {}\n\n\n.image img{\n  max-width: 80px;\n}\n\n.single-features-card {\n  border: 1px solid #E5E5E5;\n  background-color: var(--whiteColor);\n  border-radius: 25px;\n  margin-bottom: 30px;\n  padding: 40px 30px;\n  text-align: center;\n  height: 100%;\n  transition: var(--transition);\n\n  .image {\n    margin-bottom: 25px;\n  }\n  h3 {\n    margin-bottom: 13px;\n    font: {\n      size: 24px;\n      weight: 600;\n    };\n  }\n  &:hover {\n    transform: translateY(-8px);\n    box-shadow: 0px 25px 65px rgba(2, 152, 148, 0.08);\n    border: 1px solid var(--mainColor);\n  }\n  &.with-black-color {\n    text-align: start;\n    background-color: #131A34;\n    border: 1px solid #131A34;\n\n    h3 {\n      color: var(--whiteColor);\n    }\n    p {\n      color: var(--whiteColor);\n    }\n    &:hover {\n      box-shadow: unset;\n      border: 1px solid #131A34;\n    }\n  }\n}\n\n.show-phone-number{\n  background: #11b3a4;\n}\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
